import React, { useEffect } from 'react';
import MaterialTable, { Column, Icons } from 'material-table';
import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { useStyles } from '../common/tabsStyle';
import { Breadcrumbs, Chip, Link, Typography } from '@material-ui/core';
import { TaskflowMemberDialog } from '../dialogs/TaskflowMemberDialog';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { RouterProps, showNotification } from '../../App';
import gql from 'graphql-tag';
import { useQuery, useSubscription } from 'react-apollo';
import { client } from '../..';
import moment from 'moment';
import { formatDateString } from '../../helpers/DateHelper';
import { PlainTableContainer } from '../common/PlainTableContainer';

interface LookupPublicHolidayMemberMaintenanceProps extends RouterProps {
    
}

interface TableState<RowData extends object> {
    columns: Array<Column<RowData>>;
    data: RowData[];
    isFormOpen?: boolean;
}

export default function LookupPublicHolidayMemberMaintenance(props: LookupPublicHolidayMemberMaintenanceProps) {
    const classes = useStyles();

    const history = useHistory();
    
    const location = useLocation();

    const { command } = useParams<{ command: string }>();
    
    const searchParams = new URLSearchParams(location.search);

    const myKey = searchParams.get('key');
    
    const { loading, error, data, refetch } = useQuery<LookupPublicHolidayData, LookupPublicHolidayParams>(PublicHolidayQuery, {
        variables: {
            yearGuidId: myKey ? myKey : '',
        }
    });
    
    const publicHolidayNotification = useSubscription<PublicHolidayNotificationData>(PublicHolidayYearNotification);

    const [state, setState] = React.useState<TableState<PublicHoliday>>({
        columns: [
            {
                title: 'Name',
                field: 'name',
                validate: (rowData) => rowData.name === undefined || rowData.name === null || rowData.name === '' ? 'Name is required' : true,
            },
            {
                title: 'Date',
                field: 'date',
                type: 'date',
                render: (rowData) => {
                    if (!rowData.date) {
                        return null;
                    }
                    return moment(rowData.date).format('DD MMM YYYY');
                },
            }
        ],
        data: [],
        isFormOpen: false
    });

    const tableIcons: Icons = {
        // tslint:disable-next-line: no-shadowed-variable
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        // tslint:disable-next-line: no-shadowed-variable
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} className="check-button" />),
        // tslint:disable-next-line: no-shadowed-variable
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} className="check-button" />),
    };

    useEffect(() => {
            
        if (!publicHolidayNotification.error && !publicHolidayNotification.loading && publicHolidayNotification.data) {
            const notification = publicHolidayNotification.data.lookupNotification;
            if (notification && notification.status && notification.message.toLowerCase().includes('public holiday')) {
                showNotification('Public Holiday', notification.message, 'info');
            } else {
                showNotification('Failed', notification.message, 'error');
            }
            refetch();
        }
            
    }, [publicHolidayNotification.data, publicHolidayNotification.error, publicHolidayNotification.loading]);
        
    useEffect(() => {
        if (!error && data && data.lookup ) {
            setState({
                ...state,
                data: data.lookup.publicHoliday,
            });
        }
    // tslint:disable-next-line: align
    }, [data, error, loading]);

    const deleteRowData = (oldData: PublicHoliday) => {
        setState((prevState) => {
            const tdata = [...prevState.data];
            tdata.splice(tdata.indexOf(oldData), 1);
            return {
                ...prevState,
                data: tdata,
            };
        });
    };

    // tslint:disable-next-line: no-any
    // const onAdd = (event: any) => {
    //     setState((prevState) => {
    //         return {
    //             ...prevState,
    //             isFormOpen: true,
    //         };
    //     });
    // };

    // // tslint:disable-next-line: no-any
    // const onEdit = (event: any, data: PublicHoliday) => {
    //     setState((prevState) => {
    //         return {
    //             ...prevState,
    //             isFormOpen: true
    //         };
    //     });
    // };

    const handleBreadCrumbClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        history.goBack();
    };

    const onClose = () => {
        setState((prevState) => {
            return {
                ...prevState,
                isFormOpen: false
            };
        });
    };

    // const insertRowData = (newData: PublicHoliday) => {
    
    //     setState((prevState) => {

    //         const tableData = [...prevState.data];

    //         if (tableData.some((e: PublicHoliday) => e.name === newData.name)) {
    //             return { 
    //                 ...prevState, 
    //             };
    //         } 

    //         tableData.push(newData);
            
    //         return { 
    //             ...prevState, 
    //             data: tableData
    //         };
    //     });
    // };
    
    // const updateRowData  = (newData: PublicHoliday, oldData: PublicHoliday) => {
    //     setState((prevState) => {
    //         const tableData = [...prevState.data];
    //         tableData[tableData.indexOf(oldData)] = newData;
    //         return {
    //             ...prevState,
    //             data: tableData,
    //         };
    //     });
    // };
    
    const createPublicHoliday = (rowData: PublicHoliday) => {
        if (rowData) {
            const publicHolidayDateFinal = formatDateString(rowData.date);

            client
                .mutate<CreatePublicHolidayData, CreatePublicHolidayParams>({
                    mutation: CreatePublicHolidayMutation,
                    variables: {
                        name: rowData.name,
                        date: publicHolidayDateFinal,
                        publicHolidayYearId: myKey || '',
                    },
                })
                // tslint:disable-next-line: no-any
                .then((results: { data: any }) => {
                    if (results.data) {
                        if (results.data.error !== undefined) {
                            showNotification('Failed to Create Public Holiday', results.data.error, 'error');
                        }
                    }
                })
                // tslint:disable-next-line:no-any
                .catch((reason: any) => {
                    showNotification('Failed to Create Public Holiday', reason, 'error');
                });
        }
    };
    
    const updatePublickHoliday = (newData: PublicHoliday, oldData: PublicHoliday) => {
        if (newData) {
            const publicHolidayDateFinal = formatDateString(newData.date);

            client
                .mutate<UpdatePublicHolidayData, UpdatePublicHolidayParams>({
                    mutation: UpdatePublicHolidayMutation,
                    variables: {
                        guidId: newData.guid,
                        name: newData.name,
                        date: publicHolidayDateFinal,
                        publicHolidayYearId: myKey || '',
                    },
                })
                // tslint:disable-next-line: no-any
                .then((results: { data: any }) => {
                    if (results.data) {
                        if (results.data.error !== undefined) {
                            showNotification( 'Failed to Update Public Holiday', results.data.error, 'error');
                        } else {
                            // updateRowData(newData, oldData);
                        }
                    }
                })
                // tslint:disable-next-line:no-any
                .catch((reason: any) => {
                    showNotification('Failed to Update Public Holiday', reason, 'error');
                });
        }
    };
    
    const deletePublicHoliday = (oldData: PublicHoliday) => {
        client
            .mutate<DeletePublicHolidayYearResponse, DeletePublicHolidayYearParams>({
                mutation: DeletePublicHolidayMutation,
                variables: {
                    guidId: oldData.guid,
                },
            })
            // tslint:disable-next-line: no-any
            .then((results: { data: any }) => {
                if (results.data) {
                    if (results.data.error !== undefined) {
                        showNotification('Failed to Delete Public Holiday', results.data.error, 'error');
                    } else {
                        deleteRowData(oldData);
                    }
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to Delete Public Holiday', reason, 'error');
            });
    };
        
    const getTitle = (title: string, count: number) => {
        return (
            <div className={classes.breadcrumbsWrapper}>
                <Breadcrumbs separator="›" aria-label="breadcrumb" className={classes.breadcrumbs}>
                    <Link color="inherit" href="/" onClick={handleBreadCrumbClick}>
                        Public Holidays & Non-Working Days
                    </Link>
                    <Typography color="textPrimary" className={classes.breadcrumbsTitle}>{title}</Typography>
                </Breadcrumbs>
                <Chip className={classes.chip} label={state.data ? state.data.length : undefined} />
            </div>
        );
    };
    
    return (
        <div className={`${classes.root}`}>
            {state.isFormOpen && (
                <TaskflowMemberDialog 
                    maxWidth="md"
                    fullWidth={true}
                    open={state.isFormOpen}
                    onClose={onClose}
                />
            )}
            <MaterialTable<PublicHoliday>
                icons={tableIcons}
                // isLoading={loading}
                title={getTitle(command, state.data.length)}
                columns={state.columns}
                data={state.data}
                isLoading={loading}
                components={{ Container: PlainTableContainer }}
                options={{
                    addRowPosition: 'first',
                    paging: true,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 30, 40, 50],
                    draggable: true,
                    actionsColumnIndex: -1,
                }}
                editable={{
                    onRowAdd: (newData) => 
                        new Promise((resolve) => {
                            setTimeout(() => {
                                resolve(undefined);
                                createPublicHoliday(newData);
                            // tslint:disable-next-line: align
                            }, 600);
                    }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                                resolve(undefined);
                                if (oldData) {
                                    updatePublickHoliday(newData, oldData);
                                }
                            // tslint:disable-next-line: align
                            }, 600);
                    }),
                    onRowDelete: (oldData) =>
                        // tslint:disable-next-line: no-any
                        new Promise((resolve: any) => {
                            setTimeout(() => {
                                resolve();
                                if (oldData) {
                                    // handleDeletePriority(oldData);
                                    deletePublicHoliday(oldData);
                                }
                                // tslint:disable-next-line: align
                            }, 600);
                        }),
                }}
            />
        </div>
    );
}

export interface LookupPublicHolidayData {
    lookup: Lookup;
}
export interface Lookup {
    publicHoliday: PublicHoliday[];
}
export interface PublicHoliday {
    guid:                string;
    publicHolidayYearId: string;
    name:                string;
    date:                Date;
}

export interface LookupPublicHolidayParams {
    yearGuidId?: string;
    year?: number | null;
}

export const PublicHolidayQuery = gql`
    query PublicHoliday ($yearGuidId: String, $year: Int) {
        lookup {
            publicHoliday (yearGuidId: $yearGuidId, year: $year) {
                guid
                publicHolidayYearId
                name
                date
            }
        }
    }
`;

interface CreatePublicHolidayParams {
    name: string;
    date: string | null;
    publicHolidayYearId: string;
}

interface CreatePublicHolidayData {
    createPublicHoliday: boolean;
}

const CreatePublicHolidayMutation = gql`
    mutation CreatePublicHoliday($name: String, $date: DateTime, $publicHolidayYearId: String){
        createPublicHoliday(name: $name, date: $date, publicHolidayYearId: $publicHolidayYearId)
    }
`;

interface PublicHolidayNotificationData {
    lookupNotification: LookupNotification;
}

interface LookupNotification {
    id:      number;
    guidId:  string;
    message: string;
    status:  boolean;
}

const PublicHolidayYearNotification = gql`
    subscription publicHolidayYearSubscription {
        lookupNotification{
            id,
            guidId,
            message,
            status
        }
    }
`;

interface UpdatePublicHolidayParams {
    guidId: string;
    name: string;
    date: string | null;
    publicHolidayYearId: string;
}

interface UpdatePublicHolidayData {
    updatePublicHoliday: boolean;
}

const UpdatePublicHolidayMutation = gql`
    mutation UpdatePublicHoliday($guidId: String, $name: String, $date: DateTime, $publicHolidayYearId: String) {
        updatePublicHoliday(guidId: $guidId, name: $name, date: $date, publicHolidayYearId: $publicHolidayYearId)
    }
`;

interface DeletePublicHolidayYearParams {
    guidId: string;
}

interface DeletePublicHolidayYearResponse {
    deletePublicHoliday: boolean;
}

const DeletePublicHolidayMutation = gql`
    mutation DeletePublicHoliday($guidId: String) {
        deletePublicHoliday(guidId: $guidId)
    }
`;